import {useMemo, useState} from 'react'

import type {ShowSuggestionsEvent, TriggerAndSuggestions} from '../types'

// The triggerAndSuggestions array must be memoized by the caller
export const useAutocompleteTriggersAndSuggestions = (triggerAndSuggestions: TriggerAndSuggestions[]) => {
  const [event, setSuggestionEvent] = useState<ShowSuggestionsEvent | null>(null)

  const triggers = useMemo(() => triggerAndSuggestions.map(({trigger}) => trigger), [triggerAndSuggestions])

  const suggestions = useMemo(() => {
    if (!event) return null

    for (const {trigger, suggestionsCalculator} of triggerAndSuggestions) {
      if (event.trigger.triggerChar === trigger.triggerChar) {
        return suggestionsCalculator(event.query)
      }
    }

    return null
  }, [event, triggerAndSuggestions])

  const active = !!event

  return {triggers, suggestions, setSuggestionEvent, active}
}
